@if (visible$ | async) {
  <app-chart-tile [title]="'pressure-system-chart.title' | translate" [getSeries]="getSeries" [options]="options">
  </app-chart-tile>
}
